export default "__VITE_ASSET__BOPrNsvm__"